export const askFeedbackContainer = "a1dep9md";
export const feedbackSuccessContainer = "fviso31";
export const feedbackLink = "f1l1pv3";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");